import React from "react";
import { isExpired, decodeToken } from "react-jwt";

const JWT = {}

JWT.decode = (token) => {
  try {
    if (!token) {
      return {
        error: 'Token not provided',
        data: null
      };
    }

    if (isExpired(token)) {
      return {
        error: 'Token expired',
        data: null
      };
    }
    const decoded = decodeToken(token);
    if (!decoded) {
      return { error: 'Decode token error', data: null };
    }

    if (decoded.payload) {
      return {
        error: null,
        data: decoded.payload
      };
    } else {
      return {
        error: null,
        data: decoded
      };
    }

  } catch (error) {
    return {
      error: 'Decode token error',
      data: null
    };
  }
};

export default JWT;